import { FlagFragment } from 'src/graphql/generated/graphql'
import { useFlags } from 'src/react_query'
import useQueryParams from './useQueryParams'

type Flag =
  | 'Awards Page'
  | 'New Navigation'
  | 'Usersnap'
  | 'New Dashboard'
  | 'BulkOrderFlow'
  | 'DoubleBonusDashboard'
  | 'editor_choice'
  | 'can_add_act_addon'
  | 'can_purchase_act_gift_cards'
  | 'has_gift_card_wallet'
  | 'has_membership_rewards'

type Flags = {
  awardPage: boolean
  newNavigation: boolean
  userSnap: boolean
  newDashboard: boolean
  bulkOrderFlow: boolean
  doubleBonusDashboard: boolean
  editorChoice: boolean
  canAddActAddon: boolean
  canPurchaseActGiftCards: boolean
  hasGiftCardWallet: boolean
  hasMembershipRewards: boolean
}

const findFlag = (flags: string[], flag: Flag): boolean =>
  flags.find(item => item === flag) !== undefined

const getMembershipRewardsOverride = (
  paramOverride?: string,
): boolean | undefined => {
  if (process.env.NODE_ENV === 'production') return undefined

  if (paramOverride !== null && paramOverride !== undefined) {
    return paramOverride === '1' || paramOverride === 'true'
  }

  if (typeof window === 'undefined') return undefined
  const storedOverride = window.localStorage.getItem('mrFlagOverride')
  if (storedOverride === null) return undefined
  return storedOverride === '1' || storedOverride === 'true'
}

export const useFlag = (flags: FlagFragment[]): Flags => {
  const { mrFlag } = useQueryParams()
  const flagsNames: string[] = flags.map(value => value.name)
  const hasMembershipRewardsOverride = getMembershipRewardsOverride(mrFlag)

  return {
    awardPage: findFlag(flagsNames, 'Awards Page'),
    newNavigation: findFlag(flagsNames, 'New Navigation'),
    userSnap: findFlag(flagsNames, 'Usersnap'),
    newDashboard: findFlag(flagsNames, 'New Dashboard'),
    bulkOrderFlow: findFlag(flagsNames, 'BulkOrderFlow'),
    doubleBonusDashboard: findFlag(flagsNames, 'DoubleBonusDashboard'),
    editorChoice: findFlag(flagsNames, 'editor_choice'),
    canAddActAddon: findFlag(flagsNames, 'can_add_act_addon'),
    canPurchaseActGiftCards: findFlag(
      flagsNames,
      'can_purchase_act_gift_cards',
    ),
    hasGiftCardWallet: findFlag(flagsNames, 'has_gift_card_wallet'),
    hasMembershipRewards:
      hasMembershipRewardsOverride ??
      findFlag(flagsNames, 'has_membership_rewards'),
  }
}

// Use this when not using useQueries in the component
export const useFlagsWithUseQueries = (): Flags => {
  const { data: flags } = useFlags({ suspense: true })
  if (!flags) throw Error('Could not retrieve flags')
  return useFlag(flags)
}
